import { AxiosInstance } from "axios";
import { ResponseDto } from "@common/ict/model/interface/common";

export class PartnerApi {
  //获取轮播图或者宣传位 type 1: 首页轮播2: 宣传位轮播
  static getCooperationCaseList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/partners/cooperation/case/page/list`,
      {
        params: query
      }
    );
  }
  static getCooperationCaseDetail(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/partners/cooperation/case/detail`,
      {
        params: query
      }
    );
  }
  static getBiddingProject(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/supplier/bidding/project/detail`,
      {
        params: query
      }
    );
  }
  static addCooperationExpertApply(request: AxiosInstance, query) {
    return request.post<ResponseDto, ResponseDto>(
      "zh-business/client/v1/partners/cooperation/expert/apply/add",
      query
    );
  }
  static addCooperationExpertRecommend(request: AxiosInstance, query) {
    return request.post<ResponseDto, ResponseDto>(
      "zh-business/client/v1/partners/cooperation/expert/recommend/add",
      query
    );
  }
  static addCooperationCourse(request: AxiosInstance, query) {
    return request.post<ResponseDto, ResponseDto>(
      "zh-business/client/v1/partners/cooperation/qualityCourse/course/add",
      query
    );
  }
  static addSupplier(request: AxiosInstance, query) {
    return request.post<ResponseDto, ResponseDto>(
      "zh-business/client/v1/supplier/add",
      query
    );
  }

  static addBidding(request: AxiosInstance, query) {
    return request.post<ResponseDto, ResponseDto>(
      "zh-business/client/v1/supplier/bidding/apply/submit",
      query
    );
  }
  
  static downloadBidding(request: AxiosInstance, data) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/supplier/bidding/apply/file/download",
      {
        params: data,
        headers: {
          "Content-type": "multipart/form-data"
        },
        responseType: 'blob'
      }
    );
  }

  static addReport(request: AxiosInstance, query) {
    return request.post<ResponseDto, ResponseDto>(
      "zh-business/client/v1/project/report",
      query
    );
  }
}
